import { Component, OnInit } from '@angular/core';
import { history } from './history';
import { VisitsService } from 'src/app/rest_services/visits.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DashboardService } from 'src/app/rest_services/dashboard.service';
import { UserService } from 'src/app/rest_services/user.service';
import { CustomersService } from 'src/app/rest_services/customers.service';
import { Subscription } from 'rxjs';
import { MsSectorService } from 'src/app/rest_services/ms-sector.service';


interface Visite {
  AcheteurClient: String;
  Secteur: String;
  Datevisite: Date;
  Adressepostale: String;
  Ville: String;
  Affecteea: String;
}
interface History {
  Commercial: String;
  Action: String;
  Client: string;
  Dateaction: Date;
  Status: String;
}
@Component({
  selector: 'app-visite',
  templateUrl: './visites.component.html',
  styleUrls: ['./visites.component.css']
})
export class VisitesComponent implements OnInit {
  visit: any[] = [];
  archivedVisit: any[] = [];
  DataTable:any;
  visitsLoading:boolean=true;
  action: any[] = [];

  History: any[] = history;
  token:any = '';

  visit_customer:string="";
  visit_customer_sector:string="";
  visit_planned_at:Date= new Date();
  visit_customer_adress:string="";
  visit_customer_city:string="";
  visit_affected_to:string="";
  visit_status:string="";
  planned:string="";
  onDecision:string="";
  inProgress:string="";
  done:string="";
  reported:string="";
  canceled:string="";
  archived:string="";

  planifierForm: FormGroup;

  mindate:Date = new Date();

  user: any;
  role: any;
  connectedUserUuid: any = "";
  loadingMessages:boolean=false;
  messages:any[]=[];

  constructor(private fb: FormBuilder,
      private customersService:CustomersService,
      private visitServiceservice:VisitsService,
      private msSector:MsSectorService, 
      private dashboardServiceservice:DashboardService,
      private deplacementServiceservice:VisitsService, private dashboardService:DashboardService, private userService: UserService){
    this.Visit();
    // this.Actions();  
    this.planifierForm = this.fb.group({
      'planned_date': ['', Validators.required],
    })
  
  }
  loading_indicator:boolean=true;
  loading_visit:boolean=true;
  loading_actions:boolean=true;
  noPlan:number = 0;
  currentYear: any="0";

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    if(localStorage.getItem("role")!=undefined) {
      this.role =localStorage.getItem("role");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role =sessionStorage.getItem("role");
    }
    const apiToken = localStorage.getItem("token") || sessionStorage.getItem("token");
    if(apiToken){
      let decodedAPIToken = JSON.parse(window.atob(apiToken.split('.')[1]));
      this.connectedUserUuid = decodedAPIToken.userId;
    }
    this.visitsLoading =false;
    this.Visit();
    this.Deplacement();
    this.Program();
    this.selectAllCommercialsAtStart();
    this.userService.userSubject.subscribe(
      (data)=>{
        if(data.code =="f99fc2d2a6c1e8eb12bd88d1b0d05d26"){
          this.user = data.connected_user;
        }
      }
    );
  }

  initial_visits:any[] = [];
  Visit(){
    this.loading_visit = true;
    (<any>$('#alter_pagination')).DataTable().destroy();
    $('#alter_pagination tbody').empty();
    this.visitServiceservice.getVisit();
    this.visitServiceservice.visitSubject.subscribe(
      ( data: any ) => {
        this.loading_visit = false;
        if(data.code =="f380b027226aa6025571a27993cbec61" && data.visits!=undefined){          
          data.visits.forEach((visit : any) => {
            this.msSector.getSector(this.token,visit.visit_customer_sector).subscribe(
              (sectorLabel: any) => {
                visit.visit_sector = sectorLabel.label;
              },
              (error) => {
                console.log(error);
              }
            );
          });
          this.visit = data.visits.sort((a:any, b:any) => new Date(b.visit_planned_at).getTime() - new Date(a.visit_planned_at).getTime());    
        }
        this.initDataTableVisits();
      },
    )  
  }
  showRefused: boolean = false;
  showArchived:boolean=false;
  archivedVisits($event: Event) {
    const isChecked = ($event.target as HTMLInputElement).checked;
    this.showArchived = isChecked;
    if (isChecked) {
        this.showRefused = false; // décoche "Visites refusées"
    }
    (<any>$('#alter_pagination')).DataTable().destroy();
    $('#alter_pagination tbody').empty();
    if(isChecked) {
      this.loading_visit = true;
      this.visitServiceservice.getArchivedVisits();
      this.visitServiceservice.archivedVisitsSubject.subscribe(
        (data: any) => {
          this.loading_visit = false;
          if(data.code == "f380b027226aa6025571a27993cbec61") {
            if(data.visits != undefined && data.visits.length > 0) {
              // Traitement des données
              data.visits.forEach((visit: any) => {
                this.msSector.getSector(this.token, visit.visit_customer_sector).subscribe(
                  (sectorLabel: any) => {
                    visit.visit_sector = sectorLabel.label;
                  },
                  (error) => {
                    console.log(error);
                  }
                );
              });
              
              this.visit = data.visits.sort((a:any, b:any) => 
                new Date(b.visit_planned_at).getTime() - new Date(a.visit_planned_at).getTime()
              ); 
            } else {
              this.visit = [];
            }
            this.initDataTableVisits();
          }
        },
        (error) => {
          this.loading_visit = false;
          console.error(error);
        }
      );  
    } else {
      this.Visit();
    }
  }
  refusedVisits($event: Event) {
    const isChecked = ($event.target as HTMLInputElement).checked;
    this.showRefused = isChecked;
    if (isChecked) {
        this.showArchived = false; // décoche "Visites archivées"
    }
    (<any>$('#alter_pagination')).DataTable().destroy();
    $('#alter_pagination tbody').empty();
    if(isChecked) {
      this.loading_visit = true;
      this.visitServiceservice.getRefusedVisits();
      this.visitServiceservice.refusedVisitsSubject.subscribe(
        (data: any) => {
          this.loading_visit = false;
          if(data.code == "f380b027226aa6025571a27993cbec61") {
            if(data.visits != undefined && data.visits.length > 0) {
              // Traitement des données
              data.visits.forEach((visit: any) => {
                this.msSector.getSector(this.token, visit.visit_customer_sector).subscribe(
                  (sectorLabel: any) => {
                    visit.visit_sector = sectorLabel.label;
                  },
                  (error) => {
                    console.log(error);
                  }
                );
              });
              
              this.visit = data.visits.sort((a:any, b:any) => 
                new Date(b.visit_planned_at).getTime() - new Date(a.visit_planned_at).getTime()
              ); 
            } else {
              this.visit = [];
            }
            this.initDataTableVisits();
          }
        },
        (error) => {
          this.loading_visit = false;
          console.error(error);
        }
      );  
    } else {
      this.Visit();
    }
  }
  initDataTableVisits(){
    // Réinitialisation du DataTable avec un timeout pour s'assurer que le DOM est prêt
    setTimeout(() => {
      // Réinitialiser la table
      (<any>$('#alter_pagination')).DataTable({
        "pagingType": "full_numbers",
        "scrollX": '400px',
        "scrollCollapse": true,
        "aaSorting": [],
        "iDisplayLength": 25,
        "language": {
          "sProcessing": "Traitement en cours ...",
          "sLengthMenu": "Afficher _MENU_ lignes",
          "sZeroRecords": "Aucun résultat trouvé",
          "sEmptyTable": "Aucune donnée disponible",
          "sInfo": "",
          "sInfoEmpty": "",
          searchPlaceholder: "Saisir un mot clé",
          "sInfoFiltered": "",
          "sInfoPostFix": "",
          "sSearch": "Rechercher:",
          "sUrl": "",
          "sInfoThousands": ",",
          "sLoadingRecords": "Chargement...",
          "oPaginate": {
            "sFirst": "<i class='flaticon-left-arrow'></i>", 
            "sLast": "<i class='flaticon-right-arrow'></i>", 
            "sNext": "<i class='flaticon-arrow-right'></i>", 
            "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
          },
          "oAria": {
            "sSortAscending": ": Trier par ordre croissant", 
            "sSortDescending": ": Trier par ordre décroissant"
          }
        },
        drawCallback: function () {
          (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
            type: 'line',
            width: '60',
            height: '20',
            lineColor: '#1a73e9',
            fillColor: '#c2d5ff',
            spotColor: 'transparent',
            minSpotColor: 'transparent',
            maxSpotColor: 'transparent',
            highlightSpotColor: 'transparent',
            highlightLineColor: 'transparent',
          });
        }
      });
    }, 200);
  }
  Actions(){
    this.visitServiceservice.getActions("all");
    this.visitServiceservice.actionsSubject.subscribe(
      ( data: any ) => {
        if(data.code =="b8f8289ade38c75780d8156c9d8fd624"){
          this.action = data.actions;
          this.loading_actions = false;
        }
        setTimeout(()=>{
            (<any>$("#alter_paginations")).DataTable( {
              "pagingType": "full_numbers",
              "scrollX": '400px',
              order: [[3, 'desc']],
              // columnDefs: [ { type: 'date', 'targets': [3] } ],
              "scrollCollapse": false,
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "iDisplayLength": 25,
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Rechercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 500);
      },
      )  
    }
  Deplacement(){
    this.deplacementServiceservice.getDeplacement();
    this.deplacementServiceservice.deplacementSubject.subscribe(
      ( data: any ) => {
        if(data.code =="6f1c1d62a91fb719d869d50deefae736"){
          this.onDecision = data.indicators.onDecision;
          this.planned = data.indicators.planned;
          this.inProgress = data.indicators.inProgress;
          this.done = data.indicators.done;
          this.reported = data.indicators.reported;
          this.canceled = data.indicators.canceled;
          this.archived = data.indicators.archived;
          
        }this.loading_indicator = false;
      },
    )  
  }
  slots:any[]=[];
  Time(id:any){
    this.loading_indicator = true;
    this.deplacementServiceservice.getTime(id);
    this.deplacementServiceservice.timeSubject.subscribe(
      ( data: any ) => {
        if(data.code =="3a0d48a1781451973acd36b7d6c725f4"){
          this.slots=data.slots;
        }this.loading_indicator = false;
      },
    )  
  }
  commercialid:any;
  fullname_commercial:any;
  visit_id:any;
  commercial_to_validate:any;
  customer_to_validate:any;
  getTeamid(client:any){
    this.commercialid = client.visit_commercial;
    this.commercial_to_validate = client.visit_affected_to;
    this.customer_to_validate = client.visit_customer;
    this.fullname_commercial = client.visit_customer;
    this.visit_id = client.visit;
    this.Time(this.commercialid);
    //this.Planifier(this.visit_id);
  } 
  planifierRequest:any;
  plan:any;
  Planifier(){
    var formvalues = this.planifierForm.value;
    if(this.planifierForm.valid){
      this.planifierRequest = {
        planned_date :formvalues.planned_date
      }
      
      this.visitServiceservice.planifierRequest = this.planifierRequest;
      this.visitServiceservice.getPlanifier(this.visit_id);
      
      this.visitServiceservice.planifierSubject.subscribe(
      ( data: any ) => {  
        if(data.code =="a3012ec200215ec0fb7a2b3744911348"){
          this.Deplacement();
          this.plan = {
            planned_date :data.planned_date,
            visit_status : data.visit_status
          };$("#successSave").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#successSave").hide();
          }, 5000);
        }else{
          $("#error").show();
                $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#error").hide();
                }, 5000);
        }
        $("#date"+this.visit_id).html(this.planifierRequest.planned_date);
        $("#status"+this.visit_id).html("<span style='display: inline-flex;'><span class='dot dot-planifie align-self-center mr-2'></span>Planifiée</span>");
      },)
    }
  }

  getVisitToValidate(client:any){
    this.commercial_to_validate = client.visit_affected_to;
    this.customer_to_validate = client.visit_customer;
    this.fullname_commercial = client.visit_customer;
    this.visit_id = client.visit;
    this.motifRefusVisit = null;
  }
  validateVisit() {
    
  }
  motifRefusVisit:any=null;
  messageResponse:any=null;
  allValidateInProgress:boolean = false;allRefuseInProgress:boolean = false;
  allInProgress:boolean=false;
  processingVisitUuid:any = null;
  validateVisits(uuid:any,action:any){

    this.allInProgress = true;
    this.processingVisitUuid = uuid;
    var uuids:any[]=[];
    uuids.push(uuid);
    if(action=="723634aa8cde73188d4661bb3fe81ce4" && this.motifRefusVisit==null){
      this.motifRefusVisit="Réfusée !";
      this.allRefuseInProgress=true;
    }else {
      this.allValidateInProgress=true;
    }
    this.dashboardService.validateVisits(uuids,action,this.motifRefusVisit);
    this.dashboardService.validationVisitsSubject.subscribe(
      ( data: any ) => {
        if(data.code =="aaeb81b0d3c04d5fa7671d4eebde40a4"){
          this.Deplacement();
          this.messageResponse = data.message;
          this.motifRefusVisit = null;
          this.allInProgress = false;
          uuids = [];
          if(uuid!=null && (action=="f9ab05454998236921a6b0e281fae632" || action=="723634aa8cde73188d4661bb3fe81ce4")){
            const client = this.visit.find((v:any) => v.visit === uuid);
            if(client && data.visit_status){
              client.visit_status = data.visit_status;
            }
          }else {
            (<any>$('#newvisitmodal')).modal('hide');
          }
          this.processingVisitUuid = null;
          this.allValidateInProgress=false;
          this.allRefuseInProgress=false;
        }
      },
      (error:any) => {
        console.error(error);
        this.allInProgress = false;
        this.allValidateInProgress = false;
        this.allRefuseInProgress = false;
        this.processingVisitUuid = null;
      },
    )
  }
  commercialsToLaunch: any[]=[];
    Program(){
      this.noPlan=0;
      this.dashboardService.getProgram();
      this.dashboardService.programSubject.subscribe(
      ( data: any ) => {
        if(data.code =="a3012ec200215ec0fb7a2b3744911348"){
          for(let com of data.commercials){
            // if(com.visits == 0){
              this.noPlan = this.noPlan +1;
              this.commercialsToLaunch.push(com);
            // }
          }
        }
      })
    }
  loadingReviveCommercials:boolean=false;
  successRelance:number=0;

  
  Pdf(id_visit:any){
    // this.pdfOrUpdateLoading = true;
    this.dashboardService.getPdf(id_visit);
    this.dashboardService.pdfSubject.subscribe(
      ( data: any ) => {
        if(data.code =="f3030809fbd166bcc94653d58a6e6a47"){
          const source = `data:application/pdf;base64,`+data.report;
          const link = document.createElement("a");
          link.href = source;
          link.download = data.report_filename;
          link.click();
        }
      },)
  }

  MarkAsRead(visit:any){
    this.dashboardService.markAsRead(visit, null);
    this.dashboardService.markAsReadSubject.subscribe(
      ( data: any ) => {
    })
  }

  selectedCustomer:any=null;
  retrieveCustomerSubscription!:Subscription;
  retrieveCustomerLoder:boolean = false;
  retrieveCustomer(customer:any){
    this.retrieveCustomerLoder = true;
    this.selectedCustomer = null;
    this.retrieveCustomerSubscription=this.customersService.retrieveCustomer(customer,this.currentYear.toString()).subscribe(
      (data:any) => {
        if (data.code == "91cb649c3775dae97f5a003ced0791b9"){
          this.selectedCustomer = data.customer;
        }
        this.retrieveCustomerLoder = false;
      },
      (error: any) => {
        console.log(error);
        this.retrieveCustomerLoder = false;
      }
    );
    this.getConversationAboutCustomer(customer);
  }

  getConversationAboutCustomer(customerUuid:string){
    this.messages = [];
    this.loadingMessages=true;
    this.customersService.getCustomerConversation(customerUuid).subscribe(
      ( data: any ) => {
        if(data.code=="a06f376e86f9c47135aee1d1bac7b3e3") {
          this.messages = data.messagesVisit;
          $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0]?.scrollHeight }, 200)
        }
        this.loadingMessages=false;
      },
      error => {
        console.error('There was an error!', error);
      }
    )
  }
  sending: boolean = false;
  sendNewMessage(customerUuid:string){
    var message = $('#messageText').val();
    var myImage = null;
    var myavatar = this.messages.find((d:any) => d.sender== "me");
    if(myavatar!=undefined && myavatar!=null){
      myImage = myavatar.sender_avatar;
    }else {
      myImage = null;
    }            
    if(message != null && message != ""){
      this.sending = true;
      var newMessage = {
        message:message,
        sent_at:new Date(),
        sender:"me",
        sender_avatar:myImage,
        important:$("#roundedChk2").is(':checked')
      }
      var requestBody = {
        message:message,
        important:$("#roundedChk2").is(':checked')
      }
      this.customersService.sendMessage(customerUuid, requestBody).subscribe(
        ( data: any ) => {
          if(data.code=="2ea8e5510c04f55b90c85304f9f59532") {
            $('#messageText').val("");
            this.messages.push(newMessage);
            // $(".chat-messages").animate({scrollTop:$(".chat-messages")[0].scrollHeight})
            $(".chat-messages").animate({ scrollTop: $(".chat-messages")[0].scrollHeight }, 500)
            $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0].scrollHeight }, 200)
          }
          this.sending = false;
          this.loadingMessages=false;
        },
        (error:any) => {
          console.error('There was an error!', error);
        }
      );
    }
    
  }

  ngOnDestroy() {
    this.retrieveCustomerSubscription?.unsubscribe();
  }

  //#region RELANCE CODES PART
    selectedCommercialUuids: string[] = []; // Liste des UUIDs sélectionnés
    selectAllCommercials: boolean = false;

    openRelaunchModal(): void {
      // S'assurer que tous sont sélectionnés avant d'ouvrir
      this.selectAllCommercialsAtStart();
      this.commercialsToLaunch = this.commercialsToLaunch.map(commercial => ({
        ...commercial,
        selected: true  // ✅ COCHÉ PAR DÉFAUT
      }));
    }
    selectAllCommercialsAtStart(): void {
      if (this.commercialsToLaunch && this.commercialsToLaunch.length > 0) {
        this.selectedCommercialUuids = this.commercialsToLaunch.map(c => c.uuid);
      }
    }

    // Vérifie si un commercial est sélectionné
    isCommercialSelected(uuid: string): boolean {
      return this.selectedCommercialUuids.includes(uuid);
    }

    getSelectedUuids(): string[] {
      return this.commercialsToLaunch
        .filter(c => c.selected === true)
        .map(c => c.commercial);
    }

    //Gère le changement d'état d'un commercial individuel
    toggleCommercial(commercial: any, event: any): void {
      const isChecked = event.target.checked;
      // Mettre à jour l'état
      commercial.selected = isChecked;
    }

    // Envoie la relance aux commerciaux sélectionnés
    sendReviveToPlan(): void {
      if (this.selectedCommercialUuids.length === 0) {
        console.warn('Aucun commercial sélectionné');
        return;
      }      
      if(this.getSelectedUuids().length==this.commercialsToLaunch.length){
        this.sendReviveToAll();
      }else {
        this.sendReviveToMembersOfTeam();
      }
    }

    // Réinitialise les sélections (tous cochés par défaut)
    resetSelections(): void {
      this.selectAllCommercialsAtStart();
    }

    // Methode à appeler lors de l'ouverture du modal pour s'assurer que tout est coché par défaut
    openModal(): void {
      this.selectAllCommercialsAtStart();
    }

    sendReviveToAll() {
        $("#reviveError").hide();
        $("#reviveSuccess").hide();
        this.loadingReviveCommercials = true;
        this.dashboardServiceservice.sendReviveToCommercials();
        this.dashboardServiceservice.reviveCommercialsSubject.subscribe(
          ( data: any ) => {
            if(data.code =="2c4efe2ef109be62f9c9ed72434d0ad1"){
              this.successRelance=1;
              $("#reviveSuccess").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              });
              setTimeout(()=>{
                this.successRelance=0;
              }, 4000);
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                });
                $("#reviveSuccess").hide();
              }, 8000);
            }else {
              this.successRelance=2;
              $("#reviveError").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              });
              setTimeout(()=>{
                this.successRelance=0;
              }, 4000);
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                });
                $("#reviveError").hide();
              }, 8000);
            }
            this.loadingReviveCommercials = false;
          },
        )  
        setTimeout(()=>{
          this.loadingReviveCommercials = false;
          
        }, 5000);
    }
    sendReviveToMembersOfTeam() {
        $("#reviveError").hide();
        $("#reviveSuccess").hide();
        this.loadingReviveCommercials = true;
        this.dashboardServiceservice.sendReviveToSelectedCommercials(this.getSelectedUuids());
        this.dashboardServiceservice.reviveCommercialsSubject.subscribe(
          ( data: any ) => {
            if(data.code =="2c4efe2ef109be62f9c9ed72434d0ad1"){
              this.successRelance=1;
              $("#reviveSuccess").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              });
              setTimeout(()=>{
                this.successRelance=0;
              }, 4000);
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                });
                $("#reviveSuccess").hide();
              }, 8000);
            }else {
              this.successRelance=2;
              $("#reviveError").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              });
              setTimeout(()=>{
                this.successRelance=0;
              }, 4000);
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                });
                $("#reviveError").hide();
              }, 8000);
            }
            this.loadingReviveCommercials = false;
          },
        )  
        setTimeout(()=>{
          this.loadingReviveCommercials = false;
          
        }, 5000);
    }
  //#endregion

  editableVisitStatuses:string[] = ['Créée','Planifiée','En attente de validation'];
  isDescriptionEditable(client:any){
    const isOwnVisit = Boolean(this.connectedUserUuid) && client.visit_commercial === this.connectedUserUuid;
    const isCreator = Boolean(this.connectedUserUuid) && client.visit_created_by_uuid === this.connectedUserUuid;
    const canEdit = this.role === 'cmrc' || (this.role === 'adm' && (isOwnVisit || isCreator));
    return canEdit && this.editableVisitStatuses.indexOf(client.visit_status) !== -1;
  }
  editDescriptionVisit:any = null;
  editDescriptionValue:string = "";
  editDescriptionLoading:boolean = false;
  editDescriptionError:string = "";
  openEditDescription(client:any){
    this.editDescriptionVisit = client;
    this.editDescriptionValue = client.visit_goal || "";
    this.editDescriptionError = "";
  }
  isDescriptionValid(value:any){
    const v = (value || "").trim();
    return v.length >= 3 && /[a-zA-Z0-9À-ÿ]/.test(v);
  }
  saveEditDescription(){
    this.editDescriptionValue = (this.editDescriptionValue || "").trim();
    if(!this.isDescriptionValid(this.editDescriptionValue)){
      this.editDescriptionError = "Veuillez saisir une description valide (au moins 3 caractères).";
      return;
    }
    this.editDescriptionLoading = true;
    this.editDescriptionError = "";
    this.visitServiceservice.updateVisitDescription(this.editDescriptionVisit.visit, this.editDescriptionValue).subscribe(
      (data:any) => {
        this.editDescriptionLoading = false;
        if(data.code == "aec1d7a78c32d8eae4ad5125feeb5378"){
          this.editDescriptionVisit.visit_goal = this.editDescriptionValue;
          (<any>$('#editDescriptionModal')).modal('hide');
        } else if(data.code == "f538b204bae55407551398bd93bcdb04"){
          this.editDescriptionError = "Cette visite n'est plus modifiable (démarrée ou décision prise).";
        } else {
          this.editDescriptionError = "La modification n'a pas pu être enregistrée.";
        }
      },
      (error:any) => {
        this.editDescriptionLoading = false;
        this.editDescriptionError = "La modification n'a pas pu être enregistrée.";
      }
    );
  }
}
